import * as React from "react";
import { Typography, Input, Button, withStyles } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import addLogoCompany from "../../../../common/assets/images/addCompanyLogo.svg";
import { ProfileStore } from "modules/profile/ProfileStore";
import { LoginStore } from "modules/login/LoginStore";

import i18n from "i18n";
import { observer } from "mobx-react";

const styles = (theme) => ({
  companyContainer: {
    paddingTop: "65px",
    left: 0,
    top: 0,
    display: "block",
    backgroundColor: theme.palette.secondary.main,
    overflow: "auto",
    height: "calc(100vh - 64px)",
    zIndex: 2,
  },
  companyTitle: {
    fontFamily: "Roboto",
    fontSize: "18	px",
    letterSpacing: "1.2px",
    // textTransform: 'uppercase' as any,
  },
  input: {
    fontFamily: "Roboto",
    fontSize: "18px",
    fontWeight: 400,
    width: "490px",
    margin: "0 auto",
    marginTop: "30px",
    marginBottom: "70px",
    display: "block",
  },
  imagePlace: {
    top: "30px",
    width: "350px",
    height: "150px",
    border:
      ProfileStore.companyLogoURL == ""
        ? "1px solid rgb(112,112,112, 0.24)"
        : ("1px solid #ABC200" as any),
    position: "relative" as any,
    display: "block",
    margin: "0 auto",
  },
  logo: {
    width: "100%",
    margin: "25px auto",
    display: "block",
    padding: "5px",
    maxWidth: "345px",
    maxHeight: "100px",
  },
  addLogo: {
    top: "20px",
    position: "relative" as any,
    width: "55px",
    height: "55px",
    display: "block",
    opacity: 0.24,
    margin: "0 auto",
    "&:hover": {
      opacity: 1,
      cursor: "pointer",
    },
    transition: "all 0.3s ease-in",
  },
  AddLogoText: {
    fontSize: "17px",
    fontFamily: "Roboto",
    letterSpacing: "0px",
    color: "#000",
    textAlign: "center" as any,
    marginTop: "25px",
    opacity: 0.2 as any,
  },
  changeImage: {
    opacity: 0,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.7)",
    zIndex: 2,
    transition: "opacity 300ms ease-in",
    textDecoration: "none",
    position: "absolute" as any,
    "&:hover": {
      opacity: 1,
    },
  },
  imageIcon: {
    top: 15,
    left: 320,
    color: "#919191",
    zIndex: 2,
    transition: "color 200ms ease-in",
    "&:hover": {
      color: "#ffffff",
      opacity: 1,
      cursor: "pointer",
    },
  },
  changeImageText: {
    border: "1px solid",
    borderColor: "#919191",
    padding: "5px 10px",
    color: "#919191",
    width: "fit-content",
    margin: "0 auto",
    marginTop: "65px",
    height: "24px",
    borderRadius: "12px",
    fontSize: "11px",
    fontFamily: "Raleway",
    fontWeight: 700,
    transition: "all 200ms ease-in",
    "&:hover": {
      borderColor: "#ffffff",
      color: "#ffffff",
      opacity: 1,
      cursor: "pointer",
    },
    lineHeight: "120%",
    letterSpacing: "2px",
    textTransform: "uppercase" as any,
  },
  buttonSave: {
    display: "block",
    margin: "80px auto",
  },
});

type IProps = {
  classes: any;
};

@observer
class Company extends React.Component<IProps> {
  state = {
    name:
      LoginStore.userAuth != undefined ? LoginStore.userAuth.displayName : "",
    email: LoginStore.userAuth != undefined ? LoginStore.userAuth.email : "",
    disabled: false,
    userAuth: false,
    collection: "",
    companyName: ProfileStore.companyName != "" ? ProfileStore.companyName : "",
    companyLogo: ProfileStore.companyLogoURL,
  };

  componentWillMount = async () => {
    await ProfileStore.getCompanyInfos();

    this.setState({
      companyName: ProfileStore.companyName,
      companyLogo: ProfileStore.companyLogoURL,
    });
  };

  handleOpenInputFile = (e) => {
    (this.refs.inputFile as any).dispatchEvent(new MouseEvent("click"));
    this.killEvent(e);
  };

  handleChangeImage = (e) => {
    this.killEvent(e);
    let file = e.target.files[0];
    if (file) {
      var allowedExtensions = /(\.jpg|\.gif|\.png|\.svg)$/i;
      if (!allowedExtensions.exec(file.name)) {
        e.target.value = null;
        file = null;
        return;
      } else {
        var reader = new FileReader();
        reader.onload = () => {
          ProfileStore.companyLogoURL = reader.result;
          this.setState({ open: false });
        };
        reader.readAsDataURL(e.target.files[0]);
        ProfileStore.companyLogoFile = e.target.files[0];
      }
    }
    if (ProfileStore.companyInfos) {
      ProfileStore.logoUpdate = true;
    }
    ProfileStore.disableCPNBtn = false;
  };

  async handleOpenModal() {
    await ProfileStore.deleteLogo();

    ProfileStore.message = i18n.company.removeLogo;
    ProfileStore.openSnackbar = true;

    ProfileStore.companyLogoURL = "";
  }

  handleInputCompanyNameChangeEvent = (e) => {
    this.setState({ companyName: e.target.value });
    ProfileStore.companyName = this.state.companyName;
    ProfileStore.disableCPNBtn = false;
  };

  killEvent = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  render() {
    const { classes } = this.props,
      { disabled, companyName } = this.state;

    return (
      <>
        <div className={classes.companyContainer}>
          <Typography align={"center"} className={classes.companyTitle}>
            {i18n.company.companyName}
          </Typography>
          <Input
            inputProps={{
              style: { textAlign: "center" },
              maxlength: "30",
            }}
            value={companyName}
            className={classes.input}
            placeholder={i18n.company.placeholder}
            onChange={this.handleInputCompanyNameChangeEvent}
            onBlur={this.handleInputCompanyNameChangeEvent}
            disabled={disabled}
          />
          <Typography align={"center"} className={classes.companyTitle}>
            {i18n.company.companyLogo}
          </Typography>
          <div
            className={classes.imagePlace}
            style={{
              border:
                ProfileStore.companyLogoURL == ""
                  ? "1px solid rgb(112,112,112, 0.24)"
                  : ("1px solid #ABC200" as any),
            }}
          >
            {ProfileStore.companyLogoURL == "" ? (
              <>
                <input
                  key={ProfileStore.companyLogoURL}
                  type="file"
                  ref="inputFile"
                  accept=".jpg, .gif, .png, .gif, .svg"
                  onChange={this.handleChangeImage}
                  style={{ display: "none" }}
                />
                <img
                  src={addLogoCompany}
                  alt="Adicione a logo de sua empresa"
                  className={classes.addLogo}
                  onClick={this.handleOpenInputFile}
                />
                <Typography
                  className={classes.AddLogoText}
                  onClick={this.handleOpenInputFile}
                >
                  {i18n.company.chooseFile}
                </Typography>
              </>
            ) : (
              <>
                <div className={classes.changeImage}>
                  <input
                    key={ProfileStore.companyLogoURL}
                    type="file"
                    ref="inputFile"
                    accept=".jpg, .gif, .png, .gif, .svg"
                    onChange={this.handleChangeImage}
                    style={{ display: "none" }}
                  />
                  <Delete
                    style={{
                      position: "absolute",
                      marginTop: "65px !important",
                    }}
                    fontSize="small"
                    className={classes.imageIcon}
                    onClick={this.handleOpenModal}
                  />
                  <Typography
                    className={classes.changeImageText}
                    component="span"
                    onClick={this.handleOpenInputFile}
                  >
                    {i18n.company.changeImage}
                  </Typography>
                </div>
                <img
                  src={ProfileStore.companyLogoURL}
                  className={classes.logo}
                />
              </>
            )}
          </div>
          <Button
            variant="contained"
            color="primary"
            disabled={ProfileStore.disableCPNBtn}
            className={classes.buttonSave}
            onClick={() => ProfileStore.saveCompanyInfos()}
          >
            {i18n.save}
          </Button>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(Company);



// WEBPACK FOOTER //
// ./src/modules/profile/components/pages/Company.tsx